import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface RememberMeState {
  enabled: boolean
  email: string
  password: string
  remember: (email: string, password: string) => void
  forget: () => void
}

export const useRememberMeStore = create<RememberMeState>()(
  persist(
    (set) => ({
      enabled: false,
      email: '',
      password: '',
      remember: (email, password) => set({ enabled: true, email, password }),
      forget: () => set({ enabled: false, email: '', password: '' }),
    }),
    {
      name: 'rsp-plus:remember-me',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
